import { ensureError, ensureHelp, ensureLabel, type FieldType } from './base.js';
import { validateEmail, validateRequired } from '../validation.js';
import { ensureInput, withCustomMessage } from './text.js';

export const emailType: FieldType = {
  render(ctx) {
    ensureLabel(ctx.host, ctx.label, ctx.required);
    const input = ensureInput(ctx, 'email');
    input.inputMode = 'email';
    input.autocomplete = 'email';
    ensureError(ctx.host);
    ensureHelp(ctx.host, ctx.help);
  },

  getValue(ctx) {
    return ctx.host.querySelector<HTMLInputElement>(':scope > input')?.value.trim() ?? '';
  },

  validate(ctx) {
    const value = String(this.getValue(ctx));
    if (ctx.required) {
      const r = validateRequired(value);
      if (!r.valid) return withCustomMessage(r, ctx);
    }
    if (value === '') return { valid: true };
    return withCustomMessage(validateEmail(value), ctx);
  },

  shouldSubmit() {
    return true;
  },

  setDisabled(ctx, disabled) {
    const input = ctx.host.querySelector<HTMLInputElement>(':scope > input');
    if (input) input.disabled = disabled;
  },
};
